// extracted by mini-css-extract-plugin
export var compactFilters = "_ey-4";
export var detailImage = "_ey-1";
export var dropdownContainer = "_ey-2";
export var imageContainer = "_ey-0";
export var selectedCard = "_ey-3";